import type { V1ToV2MigrationEntrySource } from '../events'
import { trackAnalyticsEvent } from '../track'

interface V1ToV2MigrationEntryParams {
  source: V1ToV2MigrationEntrySource
  chainId: number
  v1VaultAddress: string
  v2VaultAddress: string
}

export function trackV1ToV2MigrationEntryViewed(params: V1ToV2MigrationEntryParams) {
  trackAnalyticsEvent('v1_to_v2_migration_entry_viewed', {
    source: params.source,
    chain_id: params.chainId,
    v1_vault_address: params.v1VaultAddress.toLowerCase(),
    v2_vault_address: params.v2VaultAddress.toLowerCase()
  })
}

export function trackV1ToV2MigrationEntryClicked(params: V1ToV2MigrationEntryParams) {
  trackAnalyticsEvent('v1_to_v2_migration_entry_clicked', {
    source: params.source,
    chain_id: params.chainId,
    v1_vault_address: params.v1VaultAddress.toLowerCase(),
    v2_vault_address: params.v2VaultAddress.toLowerCase()
  })
}
